import { PumpShiftEntity, PumpShiftFilter } from '../../models'

export const SET_PUMP_SHIFTS = 'SET_PUMP_SHIFTS'
export const SET_PUMP_SHIFTS_LOADED = 'SET_PUMP_SHIFTS_LOADED'
export const SET_PUMP_SHIFT_FILTER = 'SET_PUMP_SHIFT_FILTER'
export const SET_TOTAL_PUMP_SHIFTS = 'SET_TOTAL_PUMP_SHIFTS'
export const SET_TOTAL_AMOUNT_OF_PUMP_SHIFTS = 'SET_TOTAL_AMOUNT_OF_PUMP_SHIFTS'
export const SET_TOTAL_VOLUME_OF_PUMP_SHIFTS = 'SET_TOTAL_VOLUME_OF_PUMP_SHIFTS'

export interface PumpShiftState {
  pumpShifts: PumpShiftEntity[]
  isPumpShiftsLoaded: boolean
  pumpShiftFilter: PumpShiftFilter
  totalPumpShifts: number
  totalAmountOfPumpsShift: number
  totalVolumeOfPumpsShift: number
}

interface SetPumpShiftsAction {
  type: typeof SET_PUMP_SHIFTS
  payload: PumpShiftEntity[]
}

interface SetPumpShiftsLoadedAction {
  type: typeof SET_PUMP_SHIFTS_LOADED
  payload: boolean
}

interface SetPumpShiftFilterAction {
  type: typeof SET_PUMP_SHIFT_FILTER
  payload: PumpShiftFilter
}

interface SetTotalPumpShiftsAction {
  type: typeof SET_TOTAL_PUMP_SHIFTS
  payload: number
}

interface SetTotalAmountOfPumpShiftsAction {
  type: typeof SET_TOTAL_AMOUNT_OF_PUMP_SHIFTS
  payload: number
}

interface SetTotalVolumeOfPumpShiftsAction {
  type: typeof SET_TOTAL_VOLUME_OF_PUMP_SHIFTS
  payload: number
}

export type PumpShiftAction =
  | SetPumpShiftsAction
  | SetPumpShiftsLoadedAction
  | SetPumpShiftFilterAction
  | SetTotalPumpShiftsAction
  | SetTotalAmountOfPumpShiftsAction
  | SetTotalVolumeOfPumpShiftsAction
